export class AddName {
	constructor(name: string, remainAnonymous: boolean) {
		this.name = name;
		this.remainAnonymous = remainAnonymous;
	}

	name: string;
	remainAnonymous: boolean;
}